import {GetProductionComponentsResponse} from '../types/production.type';

interface DropdownLike {
  text: string;
  value: string;
}

type ProductionComponentsApiResponse = GetProductionComponentsResponse & {
  redactionStyle?: DropdownLike[];
  commonTIFFPDFData?: {
    redactionStyleList?: DropdownLike[] | null;
  };
};

/**
 * Detects API shape where `text` is the short code (WB/BW) and `value` is the
 * human-readable description ("White with black font").
 */
export const isCodeInTextRedactionStyleShape = (
  items: DropdownLike[]
): boolean => {
  if (!items.length) return false;
  return items.every(
    (item) =>
      typeof item.text === 'string' &&
      typeof item.value === 'string' &&
      item.text.length > 0 &&
      item.text.length <= 4 &&
      /^[A-Z0-9]+$/i.test(item.text) &&
      item.value.length > item.text.length
  );
};

/**
 * Normalizes redaction styles so:
 * - `value` = saved code (WB / BW) used for matching and save
 * - `text` = display label from API (e.g. "White with black font")
 */
export const normalizeRedactionStyleList = (
  items: DropdownLike[] | null | undefined
): DropdownLike[] => {
  if (!items?.length) return [];
  if (isCodeInTextRedactionStyleShape(items)) {
    return items.map((item) => ({
      value: item.text,
      text: item.value,
    }));
  }
  return items;
};

export const mapProductionComponentsRedactionStyles = (
  data: ProductionComponentsApiResponse
): GetProductionComponentsResponse => {
  const rawList =
    data.redactionStyleList ??
    data.commonTIFFPDFData?.redactionStyleList ??
    data.redactionStyle;

  return {
    ...data,
    redactionStyleList: normalizeRedactionStyleList(rawList ?? undefined),
  };
};
